import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EventForm from "../../components/EventForm/EventForm";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useAlert } from "react-alert";
import { Axios } from "../../App";
import * as FaIcons from "react-icons/fa";
import styles from "./EditEvent.styles";

const EditEvent = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);

  const getEventData = async () => {
    return await Axios.post("events/getEventData.php", { id: id }).then(
      ({ data }) => {
        setData(data);
      }
    );
  };

  const removeEvent = async () => {
    await Axios.post("participants/deleteAllParticipantsDataByEventID.php", {
      id: id,
    })
      .then(({ data }) => {
        if (data?.success) {
          alert.success("Siker!");
          return;
        }
        throw new Error(data?.message);
      })
      .catch((e) => {
        console.error(e);
      });
    await Axios.post("events/delete.php", { id: id })
      .then(({ data }) => {
        if (data?.success) {
          navigate("/event-manager");
          return;
        }
        throw new Error(data?.message);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const isEventExists = () => {
    return Axios.post("events/isEventExists.php", {
      id: id,
    })
      .then(({ data }) => {
        if (!data?.isExists) navigate("/event-manager");
      })
      .catch((e) => {
        console.error(e);
      });
  };

  useEffect(() => {
    const getQueries = async () => {
      isEventExists();
      getEventData();
    };

    getQueries();
  }, []);

  return (
    <div style={{ padding: "10px" }}>
      <Typography variant="h4" textAlign={"center"} m="0 0 20px 0">
        Esemény módosítása
      </Typography>
      <EventForm data={data} />
      <Box sx={styles.bottomContainer}>
        <Typography variant="overline" color="initial">Egyéb lehetőségek</Typography>
        <Divider sx={styles.divider} />
        <Button sx={styles.button} onClick={removeEvent} variant="contained" size="small" color="error" startIcon={<FaIcons.FaTrashAlt size={10} />}>
          Esemény törlése
        </Button>
      </Box>
    </div>
  );
};

export default React.memo(EditEvent);
